import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@components/common';
import CleansList from './CleansList';
import { CLEANS_LIST_TYPE } from '@services/minte';

function MyCleansList(props) {
  const { onItemClick, ...restProps } = props;
  return (
    <Box display="flex" flexDirection="column" {...restProps}>
      <CleansList
        mb={4}
        type={CLEANS_LIST_TYPE.PAST}
        onItemClick={onItemClick}
      />
      <CleansList type={CLEANS_LIST_TYPE.FUTURE} onItemClick={onItemClick} />
    </Box>
  );
}

MyCleansList.propTypes = {
  onItemClick: PropTypes.func
};

export default MyCleansList;
